import { api } from "../lib/axios"

export async function CustomersFn() {
  const response = await api.get('clients')

  return response.data
}